import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const LOG_LEVELS = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
  ACTION:'addAction'
};

// Log function that handles different levels
const log = (level, message, context) => {
  const logData = context !== undefined ? context : {};
  if(level === LOG_LEVELS.ACTION){
    datadogRum.addAction(message, logData);
    return;
  }
  datadogLogs.logger[level](message, logData);

};

const RMAXLogger = {
  debug: (message, context) => log(LOG_LEVELS.DEBUG, message, context),
  info: (message, context) => log(LOG_LEVELS.INFO, message, context),
  warn: (message, context) => log(LOG_LEVELS.WARN, message, context),
  error: (message, context) => log(LOG_LEVELS.ERROR, message, context),
  addAction: (message, context) => log(LOG_LEVELS.ACTION, message, context)
};

export { RMAXLogger };
